/* eslint-disable no-underscore-dangle, no-param-reassign */
import axios from 'axios';
import { get } from 'lodash-es';
import {
    STATE_ASSIGNED,
    STATE_ASSIGNED_SELECTED,
    STATE_UNASSIGNED,
    STATE_UNASSIGNED_SELECTED,
    STATE_UNAVAILABLE,
    STATE_NOT_DEFINED,
} from '@/components/venue_items/states';
import {
    ADD_TICKET,
    INSPECT_SEAT,
    REMOVE_TICKET,
    ADD_TO_BASKET_PENDING,
    ADD_TO_BASKET_FAILED,
    SELECT_ITEM_FOR_EDITING,
    DESELECT_ITEM_FOR_EDITING,
    TOGGLE_ITEM_SELECTION_FOR_EDITING,
    CLEAR_SELECTION,
    ASSIGN_ITEMS_PENDING,
    ASSIGN_ITEMS_COMPLETE,
    ASSIGN_ITEMS_FAILED,
    SELECT_ALL,
    BATCH_SELECT,
    FILL_TICKET_STORE,
    TOGGLE_TICKET_STORE,
    SET_BOOKING_LAYER_VISIBILITY,
    SET_ADDITIONAL_PARAMS,
    SET_PRODUCTS,
    SET_MARKETING_TITLE,
    SET_EVENT_NAME,
    ADD_TO_BASKET_SUCCESS,
    SET_ITEMS,
    SET_MAP,
} from './mutation-types';

axios.defaults.baseURL = window.__APP_CONFIG__.baseURL;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const urls = window.__APP_CONFIG__.urls;


export function inspectSeat({ commit, state }, payload) {
    commit(INSPECT_SEAT, payload);
}

export function addTicket(context, payload) {
    context.commit(ADD_TICKET, payload);
}

export function removeTicket(context, payload) {
    context.commit(REMOVE_TICKET, payload);
}

export function fillTicketStore(context) {
    context.commit(FILL_TICKET_STORE);
}

export function toggleTicketStore(context) {
    context.commit(TOGGLE_TICKET_STORE);
}

export function addToBasket(context, payload) {
    const url = get(window, '__APP_CONFIG__.urls.addToBasket');

    context.commit(ADD_TO_BASKET_PENDING);

    return new Promise((resolve, reject) => {
        if (!url) {
            context.commit(ADD_TO_BASKET_SUCCESS);
            resolve();
            return;
        }

        axios.post(urls.addToBasket, payload.data)
            .then((response) => {
                if (!response.data.success === true) {
                    context.commit(ADD_TO_BASKET_FAILED, response.data.errorMessage);
                    context.commit(FILL_TICKET_STORE);
                    reject();
                    return;
                }

                context.commit(ADD_TO_BASKET_SUCCESS);
                resolve();
            })
            .catch(() => {
                context.commit(ADD_TO_BASKET_FAILED, 'Hálózati hiba');
                reject();
            });
    });
}

export function selectItemForEditing(context, payload) {
    if (payload.state === STATE_ASSIGNED || payload.state === STATE_UNASSIGNED) {
        context.commit(SELECT_ITEM_FOR_EDITING, payload);
    }
}

export function deselectItemForEditing(context, payload) {
    if (payload.state === STATE_ASSIGNED_SELECTED || payload.state === STATE_UNASSIGNED_SELECTED) {
        context.commit(DESELECT_ITEM_FOR_EDITING, payload);
    }
}

export function toggleItemSelectionForEditing(context, vsid) {
    const i = context.state.items[vsid];

    if (
        i.state !== STATE_UNAVAILABLE &&
        i.state !== STATE_NOT_DEFINED
    ) {
        context.commit(TOGGLE_ITEM_SELECTION_FOR_EDITING, vsid);
    }
}

export function assignItems(context, payload) {
    context.commit(ASSIGN_ITEMS_PENDING, payload);

    return axios.post(urls.saveAssignment, context.state.assignments)
        .then((response) => {
            let success = true;
            let errors = [];
            const keys = Object.keys(response.data);

            keys.forEach((vsid) => {
                success = success && response.data[vsid].success;

                if (!response.data[vsid].success && response.data[vsid].message) {
                    errors.push(` ${response.data[vsid].message}`);
                }
            });

            context.commit(ASSIGN_ITEMS_COMPLETE, response.data);
            context.commit(CLEAR_SELECTION);

            if (success !== true) {
                errors = [...new Set(errors)];

                /* eslint-disable prefer-template */
                const errorMsg = errors.length ? ('<br>' + errors.join('<br>')) : '';
                const message = `Hiba történt összerendeléskor a vörös színnel jelölt helyeknél. ${errorMsg}`;

                context.commit(ASSIGN_ITEMS_FAILED, { message });
            }
        })
        .catch(() => {
            context.commit(ASSIGN_ITEMS_FAILED, { message: 'Hálózati hiba' });
        });
}

export function clearSelection(context) {
    context.commit(CLEAR_SELECTION);
}

export function selectAll(context) {
    context.commit(SELECT_ALL);
}

export function batchSelect(context, payload) {
    context.commit(BATCH_SELECT, payload);
}

export function setBookingLayerVisible(context, payload) {
    context.commit(SET_BOOKING_LAYER_VISIBILITY, payload);
}

export function setItems(context, payload) {
    context.commit(SET_ITEMS, payload);
}

export function setAdditionalParams(context, payload) {
    context.commit(SET_ADDITIONAL_PARAMS, payload);
}

export function setProducts(context, payload) {
    context.commit(SET_PRODUCTS, payload);
}

export function setMarketingTitle(context, payload) {
    context.commit(SET_MARKETING_TITLE, payload);
}

export function setEventName(context, payload) {
    context.commit(SET_EVENT_NAME, payload);
}

export function setMap(context, payload) {
    context.commit(SET_MAP, payload);
}



// WEBPACK FOOTER //
// ./src/vuex/modules/booking/actions.js